import SlidePanelRow from '@common/SlidePanel/components/SlidePanelRow';

function MenuItem({
    attributes,
    badge,
    index = '',
    liModifier = '',
    anchorModifier = '',
    url = '',
    urlPrefix,
    onClick = null,
    hasArrow = false,
    text = '',
    subText,
    icon,
    productCount,
    isActive,
    content,
    rightContent,
    rightIcon,
    theme,
    isNew,
    isUsingRouter,
    imagesSourceUrl,
    resource,
    highlight,
    isExternal = false,
    idNameSlug
}) {
    let modifiers = '';
    const customAttributes = {
        ...attributes,
        'data-uuid': index,
        'data-cs-id': idNameSlug
    };

    if (liModifier) {
        modifiers += ` ${liModifier}`;
    }

    if (anchorModifier) {
        modifiers += ` ${anchorModifier}`;
    }

    return (
        <SlidePanelRow
            badge={badge}
            content={content}
            count={productCount}
            customAttributes={customAttributes}
            customClass={modifiers}
            hasArrow={hasArrow}
            highlight={highlight}
            hint={subText}
            iconLeft={icon}
            imagesSourceUrl={imagesSourceUrl}
            isActive={isActive}
            isExternal={isExternal}
            isNew={typeof isNew !== 'undefined' && isNew}
            isUsingRouter={isUsingRouter}
            label={text}
            resource={resource}
            rightContent={rightContent}
            rightIcon={rightIcon}
            theme={theme}
            URL={isExternal ? url : `${urlPrefix}${url}`}
            onClick={onClick}
        />
    );
}

export default MenuItem;
